import Page from '../../../shared/components/Page/Page';
import {useEffect, useState} from "react";
import {Button, Form, Space, Table, Tag} from "antd";
import {formatDateTime, numberFormat} from "../../../shared/utils/helpers";
import { adminGetTransactions as getTransactions } from "../api";
import Search from "../../../shared/components/Search/Search";
import { searchPartner } from "../../partner/api";
import dayjs from "dayjs";
import {ExportOutlined} from "@ant-design/icons";
function Transaction() {
    const [dataSource,setDataSource] = useState([]);
    const [tableLoading,setTableLoading] = useState(false);
    const [form] = Form.useForm();
    const [options,setOptions] = useState([]);
    const [query,setQuery] = useState('');
    const [summaryData, setSummaryData] = useState({
        totalAmount: 0
    });
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        search: {
            createdAt: [dayjs().startOf('day'), dayjs().endOf('day')]
        }
    });
    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            sorter: true,
            align: 'center',
        },
        {
            title: 'Đối tác',
            dataIndex: 'username',
            align: 'center',
            render: (value, record) => {
                return <Tag>{record.user.username}</Tag>
            }
        },
        {
            title: 'Cộng/Trừ',
            dataIndex: 'io',
            align: 'center',
            filters: [
                {
                    text: 'Cộng tiền',
                    value: 1
                },
                {
                    text: 'Trừ tiền',
                    value: -1
                }
            ],
            render: (value) => {
                if (value === 1) {
                    return <Tag color={'blue'}>Cộng tiền</Tag>
                }
                return <Tag color={'red'}>Trừ tiền</Tag>
            }
        },
        {
            title: 'Số tiền',
            dataIndex: 'amount',
            sorter: true,
            align: 'center',
            render: (value) => {
                return numberFormat(value);
            }
        },
        {
            title: 'Số dư',
            dataIndex: 'balance',
            sorter: true,
            align: 'center',
            render: (value) => {
                return numberFormat(value);
            }
        },
        {
            title: 'Nội dung',
            dataIndex: 'description'
        },
        {
            title: 'Thời gian',
            dataIndex: 'createdAt',
            sorter: true,
            render: (value) => {
                return formatDateTime(value);
            }
        }
    ]
    const items = [
        {
            name: 'userId',
            type: 'search',
            placeholder: 'Nhập tên đối tác',
            options: options.map((item) => {
                return {
                    value: item.userId,
                    text: item.name
                }
            }),
            onSearch: (value) => {
                setQuery(value)
            }
        },
        {
            name: 'createdAt',
            type: 'date',
        }
    ]
    const fetchPartners = async () => {
        const response = await searchPartner(query);
        if (response.success) {
            setOptions(response.data)
        }
    }
    const fetchData = async () => {
        setTableLoading(true);
        const response = await getTransactions(tableParams);
        if (response.success) {
            setDataSource(response.data.data);
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    total: response.data.total
                },
            });
            setSummaryData({
                totalAmount: response.data.totalAmount
            })
        }
        setTableLoading(false);
    }
    const handleSearch =  () => {
        const params = form.getFieldsValue();
        setTableParams({
            ...tableParams,
            search: {
                ...params
            }
        })
    }
    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            ...tableParams,
            pagination,
            filters,
            sorter,
        });
    };
    useEffect(() => {
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.sorter),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.search),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.filters),
    ]);
    useEffect(() => {
        fetchPartners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])
    return (
        <Page title="Biến động số dư">
            <Space
                style={{
                    marginBottom: '20px'
                }}
            >
                <Button type={'primary'} icon={<ExportOutlined/>} title={'Xuất file'}>Xuất file</Button>
            </Space>
            <Search
                form={form}
                items={items}
                onSearch={handleSearch}
            />
            <Table
                rowKey={'uuid'}
                columns={columns}
                dataSource={dataSource}
                bordered={true}
                scroll={{
                    x: 1200
                }}
                loading={tableLoading}
                pagination={tableParams.pagination}
                onChange={handleTableChange}
                summary={(data) => {
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={3}>
                                Tổng tiền
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} align={'center'}>
                                <Tag color={'blue'}>{numberFormat(summaryData.totalAmount)}</Tag>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                    );
                }}
            />
        </Page>
    )
}
export default Transaction;